import { NgModule } from '@angular/core';
import { NgHost } from './ng-host';

@NgModule({
  declarations: [ NgHost ],
  exports: [ NgHost ],
})
export class ContribNgHostModule { }
